
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transactions/troubleshooting",
      function () {
        return require("private-next-pages/docs/transactions/troubleshooting.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transactions/troubleshooting"])
      });
    }
  